var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-text',{staticClass:"text-center"},[_c('v-icon',{attrs:{"size":"200","color":"primary lighten-4"}},[_vm._v("mdi-monitor-dashboard")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }